export const $d = (e) => document.querySelector(e);
